<form
  #orderAmendForm="ngForm"
  name="orderAmendForm"
  id="orderAmendForm"
  *ngIf="!this.isSubmitted"
>
  <nb-card style="height: 100%">
    <nb-card-header>
      <div class="row">
        <div class="col-lg-12 col-12">
          <h2>{{this.isEdit ? "Edit Amendment" : "Amendment"}}</h2>
        </div>
      </div>
    </nb-card-header>
    <nb-card-body [nbSpinner]="isLoading">
      <div class="row">
        <div class="col-lg-3 col-12">
          <nb-card>
            <nb-card-header>
              <div class="row">
                <div class="col-lg-12 col-12">
                  <h5>Customer Details</h5>
                </div>
              </div>
              <mat-divider></mat-divider>
            </nb-card-header>
            <nb-card-body>
              <div class="row">
                <div class="col-lg-12 col-12">
                  <mat-form-field style="width: 100%">
                    <mat-label>Customer</mat-label>
                    <mat-select
                      id="customer"
                      required
                      [(ngModel)]="cart.customerId"
                      name="customer"
                      #customer="ngModel"
                      [disabled]="true"
                      (ngModelChange)="onCustomerSelect()"
                    >
                      <mat-option>
                        <ngx-mat-select-search
                          [(ngModel)]="this.searchCustomer"
                          (ngModelChange)="filterCustomers()"
                          placeholderLabel="Find customer..."
                          noEntriesFoundLabel="No customer found"
                          name="customerSearch"
                          #customerSearch="ngModel"
                        >
                        </ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngIf="this.customerList.length === 0">
                        Please search for a customer.
                      </mat-option>
                      <mat-option
                        *ngFor="let customer of this.customerList"
                        [value]="customer.id"
                      >
                        {{ customer.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div
                    [hidden]="customer.valid || customer.pristine"
                    class="alert alert-danger"
                  >
                    Customer is required
                  </div>

                  <!-- Company -->
                  <mat-form-field style="width: 100%">
                    <mat-label>Company</mat-label>
                    <input
                      [(ngModel)]="this.cart.shippingAddress.company"
                      matInput
                      type="text"
                      #company="ngModel"
                      [disabled]="false"
                      id="company"
                      name="company"
                    />
                    <button
                      *ngIf="this.cart.shippingAddress.company"
                      matSuffix
                      mat-icon-button
                      aria-label="Clear"
                      (click)="this.cart.shippingAddress.company = ''"
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>

                  <!-- Shipping Address -->
                  <mat-form-field style="width: 100%">
                    <mat-label>Address</mat-label>
                    <input
                      [(ngModel)]="this.cart.shippingAddress.address"
                      matInput
                      type="text"
                      #address="ngModel"
                      [disabled]="false"
                      id="address"
                      name="address"
                    />
                    <button
                      *ngIf="this.cart.shippingAddress.address"
                      matSuffix
                      mat-icon-button
                      aria-label="Clear"
                      (click)="this.cart.shippingAddress.address = ''"
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>

                  <!-- City -->
                  <mat-form-field style="width: 100%">
                    <mat-label>City</mat-label>
                    <input
                      [(ngModel)]="this.cart.shippingAddress.city"
                      matInput
                      type="text"
                      #city="ngModel"
                      id="city"
                      [disabled]="false"
                      name="city"
                    />
                    <button
                      *ngIf="this.cart.shippingAddress.city"
                      matSuffix
                      mat-icon-button
                      aria-label="Clear"
                      (click)="this.cart.shippingAddress.city = ''"
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>

                  <!-- state -->
                  <mat-form-field>
                    <mat-label>State</mat-label>
                    <mat-select
                      id="state"
                      [disabled]="false"
                      [(ngModel)]="this.cart.shippingAddress.state"
                      name="state"
                      #state="ngModel"
                    >
                      <mat-option [value]="''">None</mat-option>
                      <mat-option
                        *ngFor="let state of this.states"
                        [value]="state.abbreviation"
                      >
                        {{ state.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <!-- Zip -->
                  <mat-form-field style="width: 100%">
                    <mat-label>Postal Code</mat-label>
                    <input
                      [(ngModel)]="this.cart.shippingAddress.zip"
                      matInput
                      type="text"
                      #zip="ngModel"
                      id="zip"
                      [disabled]="false"
                      name="zip"
                    />
                    <button
                      *ngIf="this.cart.shippingAddress.zip"
                      matSuffix
                      mat-icon-button
                      aria-label="Clear"
                      (click)="this.cart.shippingAddress.zip = ''"
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>

                  <!-- Phone -->
                  <mat-form-field style="width: 100%">
                    <mat-label>Phone #</mat-label>
                    <input
                      [(ngModel)]="this.cart.shippingAddress.phoneNumber"
                      matInput
                      type="text"
                      [disabled]="false"
                      #phoneNumber="ngModel"
                      id="phoneNumber"
                      name="phoneNumber"
                    />
                    <button
                      *ngIf="this.cart.shippingAddress.phoneNumber"
                      matSuffix
                      mat-icon-button
                      aria-label="Clear"
                      (click)="this.cart.shippingAddress.phoneNumber = ''"
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>

                  <!-- email -->
                  <mat-form-field style="width: 100%">
                    <mat-label>Email</mat-label>
                    <input
                      [(ngModel)]="this.cart.shippingAddress.email"
                      matInput
                      type="text"
                      #email="ngModel"
                      [disabled]="false"
                      id="email"
                      name="email"
                    />
                    <button
                      *ngIf="this.cart.shippingAddress.email"
                      matSuffix
                      mat-icon-button
                      aria-label="Clear"
                      (click)="this.cart.shippingAddress.email = ''"
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>

                  <!-- Contract Year-->
                  <mat-form-field style="width: 100%">
                    <mat-label>Contract Year</mat-label>
                    <input
                      [(ngModel)]="this.cart.contractYear"
                      matInput
                      type="text"
                      #contractYear="ngModel"
                      [disabled]="true"
                      id="contractYear"
                      name="contractYear"
                    />
                    <button
                      *ngIf="this.cart.contractYear"
                      matSuffix
                      mat-icon-button
                      aria-label="Clear"
                      (click)="this.cart.contractYear = ''"
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>

                  <!-- Contract Template -->
                  <mat-form-field style="width: 100%">
                    <mat-label>Contract Template</mat-label>
                    <mat-select
                      id="contractTemplate"
                      required
                      [disabled]="true"
                      [(ngModel)]="this.cart.contractTemplate"
                      name="contractTemplate"
                      #contractTemplate="ngModel"
                    >
                      <mat-option
                        *ngFor="let template of this.contractTemplates"
                        [value]="template"
                      >
                        {{ template.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-label>Effective Date</mat-label>
                  <ejs-datepicker
                    format="MM/dd/yyyy"
                    [value]="EffectiveDate"
                    (change)="onEffectiveChange($event)"
                  ></ejs-datepicker>

                  <mat-label>Expiration Date</mat-label>
                  <ejs-datepicker
                    format="MM/dd/yyyy"
                    [value]="ExpirationDate"
                    (change)="onExpirationChange($event)"
                  ></ejs-datepicker>
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>

        <!-------------------------------------------------------------------------------------------------------------------------------------->
        <div class="col-lg-9 col-12">
          <div class="row">
            <div
              *ngIf="
                this.session &&
                this.session.contract &&
                this.session.contract.contractTemplateName != 'MSA'
              "
              class="col-lg-12 col-12"
            >
              <nb-card [ngClass]="isPastDue ? 'borderColor' : ''">
                <nb-card-header>
                  <div class="row">
                    <div class="col-lg-12 col-12">
                      <h5>Order Line Items</h5>
                      <br *ngIf="isPastDue" />
                      <b
                        ><h6 style="color: darkred" *ngIf="isPastDue">
                          {{ this.cart.customer.name }} has a past due balance
                        </h6></b
                      >
                    </div>
                  </div>
                  <mat-divider></mat-divider>
                  <button
                    *ngIf="cart.customerId"
                    class="addItemButton"
                    mat-button
                    type="button"
                    (click)="addLine()"
                    style="white-space: nowrap;"
                  >
                    <fa-icon
                      style="color: #253d5b"
                      [icon]="faPlus"
                      size="lg"
                    ></fa-icon>
                    Add Line Item
                  </button>
                </nb-card-header>
                <nb-card-body style="padding-top: 5px">
                  <div style="overflow-x: auto;">
                    <table
                      class="table"
                      style="border: 0px; width: 100%"
                      id="originalTableNew"
                    >

                      <thead>
                        <tr style="text-align: center; align-content: center;">
                            <th colspan="2"><h5 style="text-align: center; color: white;"><b>Details</b></h5></th>
                            <th colspan="3"><h5 style="text-align: center; color: white;"><b>Previous</b></h5></th>
                            <th colspan="3"><h5 style="text-align: center; color: white;"><b>Amended</b></h5></th>
                            <th></th>
                        </tr>
                        <tr>
                          <th>{{ "Product" | tenantWords }}</th>
                          <th>Description</th>
                          <th>Quantity</th>
                          <th>Price/Unit</th>
                          <th>Total</th>
                          <th>Quantity</th>
                          <th>Price/Unit</th>
                          <th>Total</th>
                          <th>Delete</th>
                        </tr>
                      </thead>
                      <tbody *ngIf="cart.customerId">
                        <tr
                          *ngFor="
                            let line of this.cart.items;
                            let lineIndex = index
                          "
                          (click)="editLine(lineIndex)"
                        >
                          <!-- Product -->
                          <td style="max-width: 90px;">
                            <div *ngIf="this.selectedLineIndex !== lineIndex">{{line.inventoryItem && line.inventoryItem.name}}</div>
                            <div *ngIf="this.selectedLineIndex === lineIndex">
                              <mat-form-field style="width: 100%;">
                                <mat-label>Product</mat-label>
                                <mat-select id="product"
                                  [(ngModel)]="this.cart.items[selectedLineIndex].inventoryItem"
                                  name="product" #product="ngModel">
                                  <!-- (ngModelChange)="onItemSelect()" -->
                                  <mat-option>
                                    <ngx-mat-select-search [(ngModel)]="this.searchItemNumber"
                                      (ngModelChange)="filterProducts()"
                                      placeholderLabel="Find product..."
                                      noEntriesFoundLabel="No product found"
                                      name="productSearch"
                                      #productSearch="ngModel">
                                    </ngx-mat-select-search>
                                  </mat-option>
                                  <mat-option *ngIf="this.itemList.length === 0">
                                    Please search for an item.
                                  </mat-option>
                                  <mat-option *ngFor="let product of
                                    this.itemList" [value]="product">
                                    {{product.name}}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </td>

                          <!-- Product Description  -->
                          <td style="max-width: 150px;">
                            <div *ngIf="this.selectedLineIndex !== lineIndex">{{line.inventoryItem && line.inventoryItem.description}}</div>
                            <div *ngIf="this.selectedLineIndex === lineIndex">
                              <mat-form-field style="width: 100%;">
                                <mat-label>Description</mat-label>
                                <mat-select id="productDescription"
                                  [(ngModel)]="this.cart.items[selectedLineIndex].inventoryItem"
                                  name="productDescription" #product="ngModel">
                                  <mat-option>
                                    <ngx-mat-select-search [(ngModel)]="this.searchItemDesc"
                                      (ngModelChange)="filterProductDesc()"
                                      placeholderLabel="Find product..."
                                      noEntriesFoundLabel="No product found"
                                      name="productDescSearch"
                                      #productDescSearch="ngModel">
                                    </ngx-mat-select-search>
                                  </mat-option>
                                  <mat-option *ngIf="this.itemList.length === 0">
                                    Please search for an item.
                                  </mat-option>
                                  <mat-option *ngFor="let product of
                                    this.itemList" [value]="product">
                                    {{product.description}}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </td>
                        

                           <!-- Quantity -->
                           <td style="max-width: 100px">
                            <div>{{ line.quantity }}</div>
                          </td>

                          <!-- Price/Unit  -->
                          <td style="max-width: 100px">
                            <div>{{ line.price | currency }}</div>
                          </td>
                        
                          <!-- Total -->
                          <td>
                            {{ line.quantity * line.price | currency }}
                          </td>


                            <!-- Quantity -->
                            <td style="max-width: 100px">
                              <div *ngIf="this.selectedLineIndex !== lineIndex">
                                {{ line.quantityAmend }}
                              </div>
                              <div *ngIf="this.selectedLineIndex === lineIndex">
                                <mat-form-field style="width: 90px">
                                  <mat-label>Quantity</mat-label>
                                  <input
                                    [(ngModel)]="
                                      this.cart.items[selectedLineIndex]
                                        .quantityAmend
                                    "
                                    matInput
                                    required
                                    type="number"
                                    min="0"
                                    #lineQuantityInputAmended="ngModel"
                                    id="lineQuantityInputAmended"
                                    name="lineQuantityInputAmended"
                                  />
                                </mat-form-field>
                              </div>
                            </td>
  
                            <!-- Price/Unit  -->
                            <td style="max-width: 100px">
                              <div *ngIf="this.selectedLineIndex !== lineIndex">
                                {{ line.priceAmend | currency }}
                              </div>
                              <div *ngIf="this.selectedLineIndex === lineIndex">
                                <mat-form-field style="width: 90px">
                                  <mat-label>Price/Unit</mat-label>
                                  <input
                                    [(ngModel)]="
                                      this.cart.items[selectedLineIndex]
                                        .priceAmend
                                    "
                                    matInput
                                    type="number"
                                    #pricesAmended="ngModel"
                                    id="pricesAmended"
                                    name="pricesAmended"
                                  />
                                </mat-form-field>
                              </div>
                            </td>
  
                         
                            <!-- Total -->
                            <td>
                              {{
                                line.quantityAmend * line.priceAmend | currency
                              }}
                            </td>

                            <!-- Delete (only lines added in this amendment) -->
                            <td style="max-width: 60px;">
                              <button mat-icon-button type="button"
                                *ngIf="canDeleteLine(line)"
                                (click)="deleteLine(lineIndex); $event.stopPropagation();">
                                <fa-icon class="trashCan" [icon]="faTrash"></fa-icon>
                              </button>
                            </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td></td>
                          <td></td>
                          <td>
                            <h6><b>Total:</b></h6>
                          </td>
                          <td></td>
                          <td>
                            {{ getTotalPrice() | currency }}
                          </td>
                          <td>
                            <h6><b>Total:</b></h6>
                          </td>
                          <td></td>
                          <td>
                            {{ getTotalAmendedPrice() | currency }}
                          </td>
                          <td></td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </nb-card-body>
              </nb-card>
              <div *ngIf="this.cart.contractTemplate && this.cart.contractTemplate.name != 'MSA'" >
                <mat-form-field appearance="outline" style="width: 100%;">
                  <mat-label>Other Remarks:</mat-label>
                  <textarea matInput name="otherRemarks" #otherRemarks="ngModel" id="otherRemarks" [(ngModel)]="this.cart.contractTemplate.otherRemarks"></textarea>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nb-card-body>
    <nb-card-footer>
      <div class="row">
        <div class="col-lg-12 col-12" style="text-align: right">
          <button
            [disabled]="!this.cart.customerId"
            mat-flat-button
            type="button"
            (click)="validateContract()"
            class="button"
          >
            Save
          </button>
        </div>
      </div>
    </nb-card-footer>
  </nb-card>
</form>
